import React from "react";
import styles from "./Gallery.module.css";
const Gallery = () => {
  // Create an array of images
  const images = [
    {
      id: 1,
      src: require("../../../assets/images/channel/gallery/PVR_0002.JPG"),
      alt: "PVR 0002",
    },
    {
      id: 2,
      src: require("../../../assets/images/channel/gallery/PVR_0003.JPG"),
      alt: "PVR 0003",
    },
    {
      id: 3,
      src: require("../../../assets/images/channel/gallery/PVR_0004.JPG"),
      alt: "PVR 0004",
    },
    {
      id: 4,
      src: require("../../../assets/images/channel/gallery/PVR_0005.JPG"),
      alt: "PVR 0005",
    },
    {
      id: 5,
      src: require("../../../assets/images/channel/gallery/PVR_0006.JPG"),
      alt: "PVR 0006",
    },
    {
      id: 6,
      src: require("../../../assets/images/channel/gallery/PVR_0007.JPG"),
      alt: "PVR 0007",
    },
    {
      id: 7,
      src: require("../../../assets/images/channel/gallery/PVR_0008.JPG"),
      alt: "PVR 0008",
    },
    {
      id: 8,
      src: require("../../../assets/images/channel/gallery/PVR_0009.JPG"),
      alt: "PVR 0009",
    },
    {
      id: 9,
      src: require("../../../assets/images/channel/gallery/PVR_0010.JPG"),
      alt: "PVR 0010",
    },
    {
      id: 10,
      src: require("../../../assets/images/channel/gallery/PVR_0011.JPG"),
      alt: "PVR 0011",
    },
    {
      id: 11,
      src: require("../../../assets/images/channel/gallery/PVR_0012.JPG"),
      alt: "PVR 0012",
    },
    {
      id: 12,
      src: require("../../../assets/images/channel/gallery/PVR_0013.JPG"),
      alt: "PVR 0013",
    },
    {
      id: 13,
      src: require("../../../assets/images/channel/gallery/PVR_0014.JPG"),
      alt: "PVR 0014",
    },
    {
      id: 14,
      src: require("../../../assets/images/channel/gallery/PVR_0015.JPG"),
      alt: "PVR 0015",
    },
    {
      id: 15,
      src: require("../../../assets/images/channel/gallery/PVR_0016.JPG"),
      alt: "PVR 0016",
    },
    {
      id: 16,
      src: require("../../../assets/images/channel/gallery/PVR_0017.JPG"),
      alt: "PVR 0017",
    },
    {
      id: 17,
      src: require("../../../assets/images/channel/gallery/PVR_0018.JPG"),
      alt: "PVR 0018",
    },
    {
      id: 18,
      src: require("../../../assets/images/channel/gallery/PVR_0019.JPG"),
      alt: "PVR 0019",
    },
    {
      id: 19,
      src: require("../../../assets/images/channel/gallery/PVR_0020.JPG"),
      alt: "PVR 0020",
    },
    {
      id: 20,
      src: require("../../../assets/images/channel/gallery/PVR_0021.JPG"),
      alt: "PVR 0021",
    },
    {
      id: 21,
      src: require("../../../assets/images/channel/gallery/PVR_0022.JPG"),
      alt: "PVR 0022",
    },
    {
      id: 22,
      src: require("../../../assets/images/channel/gallery/PVR_0028.JPG"),
      alt: "PVR 0028",
    },
    {
      id: 23,
      src: require("../../../assets/images/channel/gallery/PVR_0031.JPG"),
      alt: "PVR 0031",
    },
    {
      id: 24,
      src: require("../../../assets/images/channel/gallery/PVR_0032.JPG"),
      alt: "PVR 0032",
    },
    {
      id: 25,
      src: require("../../../assets/images/channel/gallery/PVR_0037.JPG"),
      alt: "PVR 0037",
    },
    {
      id: 26,
      src: require("../../../assets/images/channel/gallery/PVR_0038.JPG"),
      alt: "PVR 0038",
    },
    {
      id: 27,
      src: require("../../../assets/images/channel/gallery/PVR_0042.JPG"),
      alt: "PVR 0042",
    },
    {
      id: 28,
      src: require("../../../assets/images/channel/gallery/PVR_0044.JPG"),
      alt: "PVR 0044",
    },
  ];
  return (
    <section className={styles.gallery}>
      <div className={styles.container}>
        <h2 data-aos="fade-up">Sneak Peak into STEMx STUDIO'S</h2>
        <div className={styles.grid}>
          {images.map((image) => (
            <div
              key={image.id}
              className={styles.imageWrapper}
              data-aos="fade-up"
            >
              <div className={styles.imagePlaceholder}>
                <img src={image.src} alt={image.alt} className={styles.image} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
